import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { Header, Menu, ContactForm, Footer, CTA } from './components';

export var MainContext = React.createContext();

const head = {
	link: [
		// Define favicon
		{ rel: 'shortcut icon', href: '/images/favicon/favicon.ico', type: 'image/x-icon' },
		{ rel: 'icon', sizes: '16x16 32x32 64x64', href: '/images/favicon/favicon.ico' },
		{ rel: 'icon', type: 'image/png', sizes: '196x196', href: '/images/favicon/favicon-192.png' },
		{ rel: 'icon', type: 'image/png', sizes: '160x160', href: '/images/favicon/favicon-160.png' },
		{ rel: 'icon', type: 'image/png', sizes: '96x96', href: '/images/favicon/favicon-96.png' },
		{ rel: 'icon', type: 'image/png', sizes: '64x64', href: '/images/favicon/favicon-64.png' },
		{ rel: 'icon', type: 'image/png', sizes: '32x32', href: '/images/favicon/favicon-32.png' },
		{ rel: 'icon', type: 'image/png', sizes: '16x16', href: '/images/favicon/favicon-16.png' },
		{ rel: 'apple-touch-icon', href: '/images/favicon/favicon-57.png' },
		{ rel: 'apple-touch-icon', sizes: '114x114', href: '/images/favicon/favicon-114.png' },
		{ rel: 'apple-touch-icon', sizes: '72x72', href: '/images/favicon/favicon-72.png' },
		{ rel: 'apple-touch-icon', sizes: '144x144', href: '/images/favicon/favicon-144.png' },
		{ rel: 'apple-touch-icon', sizes: '60x60', href: '/images/favicon/favicon-60.png' },
		{ rel: 'apple-touch-icon', sizes: '120x120', href: '/images/favicon/favicon-120.png' },
		{ rel: 'apple-touch-icon', sizes: '76x76', href: '/images/favicon/favicon-76.png' },
		{ rel: 'apple-touch-icon', sizes: '152x152', href: '/images/favicon/favicon-152.png' },
		{ rel: 'apple-touch-icon', sizes: '180x180', href: '/images/favicon/favicon-180.png' }
	],
	meta: [
		{ charset: 'utf-8' },
		{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
		{ 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },

		// IE favicon spec
		{ name: 'msapplication-TileColor', content: '#FFFFFF' },
		{ name: 'msapplication-TileImage', content: '/images/favicon/favicon-144.png' },
		{ name: 'msapplication-config', content: '/images/favicon/browserconfig.xml' }
	],
};

class App extends Component {
	constructor (props) {
		super(props);

		this.appRef = React.createRef()
	}

	state = {
		contactFormOpened: false,
		headroomEnabled: false,
		loadBody: false,
	}

	toggleContactForm = (value) => {
		this.setState({
			contactFormOpened: value || !this.state.contactFormOpened
		})
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			gtag('event', 'page_view', { 'send_to': 'UA-64250426-4' });
		}
	}

	componentDidMount() {
		this.setState({
			headroomEnabled: true
		})
	}

	render () {
		const { contactFormOpened } = this.state

		const contextValue = {
			contactFormOpened,
			toggleContactForm: this.toggleContactForm
		}

		if (!this.state.loadBody) {
			setTimeout(() => {
				this.setState({ loadBody: true });
			}, 500)
		}

		return (
			<MainContext.Provider value={contextValue}>
				<AppContainer id="App" scrollBlocked={contactFormOpened}>
					<Helmet
						titleTemplate="%s"
						meta={head.meta}
						link={head.link}
					/>
					
					<Header />
					<ContactForm />
					{ this.state.loadBody ? this.props.children : null }
					<CTA />
					<Footer />
				</AppContainer>
			</MainContext.Provider>
		);
	}
};

const AppContainer = styled.div`
	overflow: ${props => props.scrollBlocked ? 'hidden' : 'auto'}
`

export default withRouter(App)


// WEBPACK FOOTER //
// ./client/App.js